<template>
    <v-checkbox
        v-model="model[config.key]" :dense="config.dense" :required="config.required" :rules="config.rules"
        :label="config.label" :readonly="isReadonly" @change="config.change">
    </v-checkbox>
</template>

<script>

export default {
    name: 'FormCheckBox',
    props: ['config', 'model'],
    computed: {
        isReadonly() {
            return this.config.isReadonly && this.config.isReadonly(this.model);
        }
    }
}
</script>
